import { computed } from 'nanostores'
import type { Dayjs } from 'dayjs'

import { $discountOptions, $discountOptionWeeks } from './stores'
import { $loggedInSettings } from '../logged-in-settings/stores'

export const $discountOption = computed(
  [$discountOptions, $loggedInSettings],
  (discountOptions, loggedInSettings) => {
    const discountOptionId =
      loggedInSettings?.discountCampaign?.discountOptions?.discountId
    return discountOptionId ? discountOptions[discountOptionId] : undefined
  },
)

export const $isDiscountOptionApplied = computed(
  [$discountOptionWeeks],
  (discountOptionWeeks) =>
    (subscriptionId: number, discountOptionId: number, week?: Dayjs) => {
      const subscriptionDiscountOptionWeeks =
        discountOptionWeeks[subscriptionId]
      if (!subscriptionDiscountOptionWeeks) return false

      return subscriptionDiscountOptionWeeks.some(
        ({ discountOptionId: appliedDiscountOptionId, week: discountWeek }) => {
          if (week) {
            return (
              week.isSame(discountWeek) &&
              discountOptionId === appliedDiscountOptionId
            )
          }

          return discountOptionId === appliedDiscountOptionId
        },
      )
    },
)
